<template>
    <div id="datatime_picker">
        <div @click="el_date_picker_on_click()">
            <el-date-picker
                v-model="start"
                :type="current_type"
                :editable="false"
                :placeholder="$t('ui.el.datepicker.selectDateTime')">
            </el-date-picker>
            <div style="margin-top: 6px;" v-if="!is_date"></div>
            <el-date-picker
                v-model="end"
                v-if="!is_date"
                :type="current_type"
                :editable="false"
                :placeholder="$t('ui.el.datepicker.selectDateTime')">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        index: Number,
        is_date: Boolean,
        re_init: Boolean,
        type: {
            type: String,
            default: () => { return 'daterange' }
        },
    },
    data() {
        return {
            current_value: null,
            is_clicked: false,
            start: null,
            end: null,
        }
    },
    computed: {
        current_type() {
            return (this.type == 'datetimerange' || this.type == 'datetime') ? 'datetime' : 'date'
        }
    },
    watch: {
        start(val) {
            this.update_value([val, this.end])
        },
        end(val) {
            this.update_value([this.start, val])
        },
        re_init(val) {
            this.init()
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                let default_value = null
                try {
                    default_value = this.$vnode.data.props.value
                    if (default_value) {
                        if (Array.isArray(default_value)) {
                            this.start = default_value[0]
                            this.end = default_value[1]
                        } else {
                            this.start[0] = default_value
                        }
                    }
                    this.$forceUpdate()
                } catch (e) {

                }
                resolve()
            })
        },
        el_date_picker_on_click() {
            setTimeout(() => {
                let el_inputs = document.querySelectorAll('.el-input__inner')
                for (var i = 0; i < el_inputs.length; i++) {
                    el_inputs[i].readOnly = true
                }
            }, 200)
        },
        update_value(vals) {
            let result = vals
            let cache = []
            if (result[0] && result[1]) {
                if (this.$moment(result[1]).isBefore(result[0])) {
                    cache[0] = result[1]
                    cache[1] = result[0]
                    result = cache
                }
            }
            this.$emit('update', result)
        },
    },
}
</script>

<style lang="scss" scoped>
    #datatime_picker {
        margin-top: 12px;
    }
</style>
